import './style.scss'

const Loader = () => {
  return (
    <div className='loader'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='56px'
        height='56px'
        viewBox='0 0 100 100'
        preserveAspectRatio='xMidYMid'
        strokeLinecap="round"
      >
        <circle
          cx='50'
          cy='50'
          fill='none'
          stroke='#8A8A8A'
          stroke-width='10'
          r='43'
          stroke-dasharray='164.93361431346415 56.97787143782138'
        ></circle>
      </svg>
    </div>
  );
};
export default Loader;
